<div *ngIf="!isBrowserSupported()" class="alert alert-warning">
  Algunas de las funcionalidades del sistema pueden operar de forma incorrecta
  en el navegador que estas utilizando. Te recomendamos utilizar el servicio en
  <strong>google chrome</strong> o <strong>mozilla firefox</strong> en sus
  últimas versiones
</div>
